import {
  FormControl,
  FormHelperText,
  InputAdornment,
  makeStyles,
  OutlinedInput
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(
  {
    disabled: {
      "& div": {
        backgroundColor: "#F1F2F3",
        borderColor: "#F1F2F3"
      },
      pointerEvents: "none"
    },
    formHelperText: {
      fontSize: "9px",
      margin: "0 !important",
      minWidth: "180px"
    },
    input: {
      height: "68px",
      minWidth: "180px",
      padding: "10px 0 0",
      width: "100%"
    },
    inputAdornment: {
      "& *": {
        fontWeight: "bold"
      }
    },
    outlinedInput: {
      "& input": {
        padding: "10px 12px 10px 12px !important"
      }
    }
  },
  { name: "CustomNumberInput" }
);

interface CustomNumberInputProps {
  id?: string;
  label: string;
  value: any;
  error?: boolean;
  errorText?: string;
  disabled?: boolean;
  onChange?(e): any;
  onBlur?(e): any;
}

export const CustomNumberInput: React.FC<CustomNumberInputProps> = props => {
  const {
    id,
    label,
    value,
    error,
    errorText,
    disabled,
    onChange,
    onBlur
  } = props;
  const classes = useStyles(props);

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    if (disabled && e.key !== "Tab") {
      e.preventDefault();
    }

    const specialKeys = [
      "Backspace",
      "Tab",
      "End",
      "Home",
      "ArrowLeft",
      "ArrowRight",
      "Del",
      "Delete"
    ];
    if (specialKeys.includes(e.key)) {
      return;
    }

    if (e.key === "." && (value || "").includes(".")) {
      e.preventDefault();
      return;
    }

    const current: string = value || "";
    const position = (e.target as HTMLInputElement).selectionStart || 0;

    const next = [
      current.slice(0, Math.max(0, position)),
      e.key === "Decimal" ? "." : e.key,
      current.slice(Math.max(0, position))
    ].join("");

    const regex = /^\d{0,9}(\.\d{0,2})?$/;
    if (!regex.test(next)) {
      e.preventDefault();
    }
  };

  const handleOnBlur = (
    e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <FormControl
      variant="outlined"
      className={
        disabled ? `${classes.input} ${classes.disabled}` : `${classes.input}`
      }
    >
      <OutlinedInput
        id={id ? id : "customNumberInput"}
        type="text"
        error={error}
        className={classes.outlinedInput}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        onBlur={handleOnBlur}
        endAdornment={
          <InputAdornment className={classes.inputAdornment} position="end">
            {label}
          </InputAdornment>
        }
        labelWidth={0}
      />
      {error && (
        <FormHelperText error className={classes.formHelperText}>
          {errorText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

CustomNumberInput.displayName = "CustomNumberInput";
export default CustomNumberInput;
